import { connect } from 'react-redux';
import TeamGroupsPage from '../TeamGroupsPage';
import {
  setAction,
  getPermissionsAction,
  getGroupPermissionsAction,
  setGroupAction,
  updateGroupAction,
  deleteGroupAction,
  setGroupPermissionsAction,
} from '../actions/teamGroupsPage.js';
import { checkPermission, checkPlanPermission, loadGroups } from '../../../utils/ProfileHelpers';
import { getActiveGroup } from '../selectors/teamGroups';

const mapStateToProps = (state) => {
  return {
    paths: state.app.paths || {},
    groups: state.profile.groups,
    team: state.profile.team,
    division: state.profile.division,
    error: state.teamGroupsPage.error,
    permissions: state.teamGroupsPage.permissions,
    groupId: state.teamGroupsPage.groupId,
    groupPermissionsDb: state.teamGroupsPage.groupPermissionsDb,
    groupPermissions: state.teamGroupsPage.groupPermissions,
    modal: state.teamGroupsPage.modal,
    newGroupName: state.teamGroupsPage.newGroupName,
    unsavedChanges: state.teamGroupsPage.unsavedChanges,
    groupName: state.teamGroupsPage.groupName,
    editGroupNameError: state.teamGroupsPage.editGroupNameError,
    loadGroups: loadGroups,
    group: getActiveGroup({
      groups: state.profile.groups,
      groupId: state.teamGroupsPage.groupId,
    }),
    checkPermission: (permission) => checkPermission(permission, state.profile),
    checkPlanPermission: (permission) => checkPlanPermission(permission, state.profile),
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadPermissions: () => dispatch(getPermissionsAction()),
  loadGroupPermissions: (team, group) => dispatch(getGroupPermissionsAction({ team, group })),
  addGroup: (team, newGroupName) => dispatch(setGroupAction({ team, newGroupName })),
  editGroup: (team, groups, groupId, newGroupName) =>
    dispatch(updateGroupAction({ team, groups, groupId, newGroupName })),
  deleteGroup: (team, groupId) => dispatch(deleteGroupAction({ team, groupId })),
  saveGroupPermissions: (team, permissions, groupId, groupPermissions, groupPermissionsDb) =>
    dispatch(setGroupPermissionsAction({ team, permissions, groupId, groupPermissions, groupPermissionsDb })),
  set: (params) => dispatch(setAction(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamGroupsPage);
